module.exports = __webpack_public_path__ + "static/media/youtube.5fda00f7.jpg";